<template>
    <footer id="footer">
        <b-container>
        <b-row class="align-items-center">
            <b-col cols="12" md="4" class="footer-item">
                <div class="footer-title">UO Konsult AB</div>
                <div>556213-4477</div>
            </b-col>
             <b-col cols="12" md="4" class="footer-item">
                 <div>Bråland 330</div>
                 <div>444 92, Jörlanda</div>
            </b-col>
             <b-col cols="12" md="4" class="footer-item">
                 <a href="mailto:ritningar.se@outlook.com" class="footer-mail">
                     <inline-svg :src="svg('mail.svg')" width="18" height="18" />
                     <span>ritningar.se@outlook.com</span>
                 </a>
                 <div class="footer-copyright">Copyright UO Konsult AB {{year}}</div>
            </b-col>
        </b-row>
        </b-container>
    </footer>
</template>


<script>

export default {
    name: "Footer",
    computed: {
       year(){
           var d = new Date();
           return d.getFullYear();
       }
    },
    methods: {
        svg(path) {
            return this.$images.svg(path)
        }
    }
};
</script>
